import React, { useEffect, useState, useRef } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { DataCard } from '../components/DataCard';
import { usePublicaciones } from '../hooks/usePublicaciones';
import { INotificacion } from '../models/publicaciones';
import { formatToDDMMYYYY } from '../utils/date';

export const Notificaciones = () => {
  const { getNotificaciones, marcarNotificacionLeida, marcarTodasLeidas } = usePublicaciones();
  const [notificaciones, setNotificaciones] = useState<INotificacion[]>([]);
  const [visibleCount, setVisibleCount] = useState(30);
  const interactedIds = useRef(new Set());

  useEffect(() => {
    getNotificaciones()
    .then(data => {
      const reversedData = [...data].reverse();
      setNotificaciones(reversedData);
    })
    .catch(err => console.error(err));

  }, [getNotificaciones]);

  const handleLoadMore = () => {
    setVisibleCount(prevCount => prevCount + 30);
  };

  const handleMarkAsRead = async (correlativo: number) => {
    if (interactedIds.current.has(correlativo)) {
      return;
    }
    await marcarNotificacionLeida(correlativo);
    setNotificaciones(prev =>
      prev.map(n => (n.correlativo === correlativo ? { ...n, estado: 1 } : n))
    );
    interactedIds.current.add(correlativo);
  };

  const handleMarkAllAsRead = async () => {
    await marcarTodasLeidas();
    setNotificaciones(prev => prev.map(n => ({ ...n, estado: 1 })));
  };

  return (
    <Box textAlign="center" display="flex" alignItems="center" flexDirection='column'>
      <Typography variant="h4" component="div" gutterBottom marginY='1em'>
        Notificaciones
      </Typography>
      {notificaciones.some(n => n.estado === 0) && (
        <Box mb={2}>
          <Button
            variant="contained"
            onClick={handleMarkAllAsRead}
          >
            Marcar todas como leídas
          </Button>
        </Box>
      )}
      <Box textAlign={'left'} width="100%" paddingX={2}>
        {
          notificaciones.length > 0
            ? notificaciones.slice(0, visibleCount).map(el => (
              <div
                key={el.correlativo}
                style={{ fontWeight: el.estado === 0 ? 'bold' : 'normal', marginBottom: '1em' }}
                onMouseEnter={() => el.estado === 0 && handleMarkAsRead(el.correlativo)}
              >
                <DataCard
                  data={{
                    titulo: 'Notificación',
                    fecha: formatToDDMMYYYY(el.fecha),
                    descripcion: el.texto,
                  }}
                  unread={el.estado === 0}
                  onClick={() => {
                    if (el.estado === 0) {
                      handleMarkAsRead(el.correlativo);
                    }
                  }}
                />
              </div>
            ))
            : <div> No hay notificaciones... </div>
        }
        {visibleCount < notificaciones.length && (
          <Box textAlign="center" paddingY={2}>
            <Button variant="contained" onClick={handleLoadMore}>
              Cargar más
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  )
}